import Parse from 'html-react-parser';

function BMP20146(props) {
    let svgCode =
    `<svg width="362" height="112" viewBox="0 0 362 112" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_f)">
        <rect x="25" y="27" width="306" height="56" rx="15" fill="${props.paramFill}" fill-opacity="0.6"/>
        </g>
        <rect x="12" y="12" width="306" height="56" rx="15" fill="${props.paramFill}"/>
    <defs>
    <filter id="filter0_f" x="11" y="13" width="334" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur"/>
    </filter>
    </defs>
    </svg>`

    props.svgReturn(99, svgCode, "bmp00146", 362, 112);

    return (
        Parse(svgCode)
    );
}

export default BMP20146;